<template>
  <transition
    :enterActiveClass="$style.slideEnterActive"
    :enterClass="$style.slideEnter"
    :leaveActiveClass="$style.slideLeaveActive"
    :leaveToClass="$style.slideLeaveTo"
  >
    <section v-if="showHeaders">
      <div :class="$style.columnsHeadersContainer">
        <div :class="$style.columnHeader">
          <b>SCIM Attribute Name</b>
          <TooltipIcon
            icon="info"
            linkHref="https://tools.ietf.org/html/rfc7643#section-8.2"
            linkText="Learn More"
            text="Only core SCIM attributes are supported."
          />
        </div>
        <div :class="$style.columnHeader">
          <b>JumpCloud Attribute Name</b>
        </div>
      </div>
      <ListEditor
        :class="$style.listEditor"
        :component="ScimConnectorAttributeField"
        :handleChangeListItem="handleChangeListItem"
        :handleRemoveListItem="handleRemoveListItem"
        headerText=""
        :listItems="listItems"
        :showHeader="false"
      />
    </section>
  </transition>
</template>

<script>
import { TooltipIcon } from '@jumpcloud/ui-components';
import IdentityManagementMixin from 'client/applications/mixins/IdentityManagementMixin';
import ListEditor from 'client/components/FormValidation/ListEditor';
import ScimConnectorAttributeField from 'client/applications/scim/ScimConnectorAttributeField.vue';

export default {
  name: 'GenericScimAttributesListEditor',

  components: {
    ListEditor,
    TooltipIcon,
  },

  inject: ['$validator'],

  mixins: [
    IdentityManagementMixin,
  ],

  props: {
    handleChangeListItem: {
      type: Function,
      required: true,
    },
    handleRemoveListItem: {
      type: Function,
      required: true,
    },
    listItems: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      ScimConnectorAttributeField,
    };
  },

  computed: {
    showHeaders() {
      return (this.translationRules.length > 0);
    },
  },
};
</script>

<style module>
@import './css/IdentityManagementCommon.css';

@value (jcGrey600) from '~css/brand-colors.css';

.columnsHeadersContainer {
  display: flex;
  margin-bottom: 5px;
  width: calc(100% - 1.5rem - 220px);
}

.columnHeader {
  align-items: center;
  color: jcGrey600;
  display: flex;
}

.columnHeader:first-child {
  flex: 1 1 auto;
  padding-left: 0.3rem;
}

.columnHeader:last-child {
  flex: 1 1 auto;
  padding-left: 1.4rem;
}
</style>
